// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__yekanFa_0d3348', '__yekanFa_Fallback_0d3348', yekanbakh, tahoma, Arial"},"className":"__className_0d3348"};